var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { legalDepositsPeriodicalIssuesIdAgenda, legalDepositsPeriodicalIssuesIdLinkMembership, legalDepositsPeriodicalIssuesIdMonographLink, legalDepositsTitlesIdAgenda, legalDepositsTitlesIdAgendaHistory, legalDepositsTitlesIdGlobalType, legalDepositsTitlesIdSpecialIssueLink, legalDepositsSpecialIssueLinksPeriodicals, legalDepositsSpecialIssueLinksPeriodicalsIdIssues, legalDepositsSpecialIssueLinksPeriodicalsIdVolumes, } from "../types/apiPaths";
var changeParams = function (dryRun, note) {
    var searchParams = new URLSearchParams();
    searchParams.append("dryRun", String(dryRun));
    if (note)
        searchParams.append("note", note);
    return searchParams;
};
export var fetchTitleAgenda = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsTitlesIdAgenda(titleId), { headers: getHeaders() })
                .json()];
    });
}); };
export var fetchTitleAgendaHistory = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsTitlesIdAgendaHistory(titleId), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var setTitleAgenda = function (kyInstance, titleId, request, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .put(legalDepositsTitlesIdAgenda(titleId), {
                json: request,
                searchParams: changeParams(dryRun),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var setGlobalType = function (kyInstance, titleId, request, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .put(legalDepositsTitlesIdGlobalType(titleId), {
                json: request,
                searchParams: changeParams(dryRun),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchIssueAgenda = function (kyInstance, issueId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsPeriodicalIssuesIdAgenda(issueId), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var setIssueAgenda = function (kyInstance, issueId, request, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .put(legalDepositsPeriodicalIssuesIdAgenda(issueId), {
                json: request,
                searchParams: changeParams(dryRun),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var linkIssueToMonograph = function (kyInstance, issueId, request, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .put(legalDepositsPeriodicalIssuesIdMonographLink(issueId), {
                json: request,
                searchParams: changeParams(dryRun),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var unlinkIssueFromMonograph = function (kyInstance, issueId, note, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .delete(legalDepositsPeriodicalIssuesIdMonographLink(issueId), {
                searchParams: changeParams(dryRun, note),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var leaveIssueLink = function (kyInstance, issueId, note, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .delete(legalDepositsPeriodicalIssuesIdLinkMembership(issueId), {
                searchParams: changeParams(dryRun, note),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var createSpecialIssueLink = function (kyInstance, monographTitleId, request, dryRun) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsTitlesIdSpecialIssueLink(monographTitleId), {
                json: request,
                searchParams: changeParams(dryRun),
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var LINKABLE_PERIODICALS_LIMIT = 20;
export var fetchLinkablePeriodicals = function (kyInstance, search) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsSpecialIssueLinksPeriodicals, {
                searchParams: {
                    search: search,
                    offset: 0,
                    limit: LINKABLE_PERIODICALS_LIMIT,
                    exactCount: false,
                },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchLinkableVolumes = function (kyInstance, periodicalTitleId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsSpecialIssueLinksPeriodicalsIdVolumes(periodicalTitleId), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchLinkableIssues = function (kyInstance, periodicalTitleId, volumeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsSpecialIssueLinksPeriodicalsIdIssues(periodicalTitleId), {
                searchParams: { volumeId: volumeId },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
